/**
 * Resource types and interfaces for the Resource Hub feature
 */

/**
 * Resource content type enum
 */
export enum ResourceType {
  ARTICLE = 'ARTICLE',
  VIDEO = 'VIDEO',
  PODCAST = 'PODCAST',
  GUIDE = 'GUIDE',
  CHECKLIST = 'CHECKLIST',
}

/**
 * Resource category enum (aligned with journey types)
 */
export enum ResourceCategory {
  AGING_IN_PLACE = 'AGING_IN_PLACE',
  HOME_TRANSITION = 'HOME_TRANSITION',
  END_OF_LIFE_CARE = 'END_OF_LIFE_CARE',
  AFTER_LOSS_SUPPORT = 'AFTER_LOSS_SUPPORT',
  ADVISOR_RESOURCES = 'ADVISOR_RESOURCES',
}

/**
 * Resource entity from API
 */
export type Resource = {
  id: string;
  title: string;
  description: string;
  contentType: ResourceType;
  content: string;
  category: ResourceCategory;
  subcategories: string[];
  tags: string[];
  authorId?: string;
  authorName?: string;
  isFeatured: boolean;
  shareCount: number;
  createdAt: string;
  updatedAt: string;
  // Additional fields for display
  thumbnailUrl?: string;
  duration?: string; // For videos/podcasts
  readTime?: string; // For articles
  views?: string;
};

/**
 * Search filters for resources
 */
export type ResourceSearchFilters = {
  query?: string;
  contentType?: ResourceType;
  category?: ResourceCategory;
  tags?: string[];
};

/**
 * Resource list response with pagination
 */
export type ResourceListResponse = {
  resources: Resource[];
  total: number;
  page: number;
  pageSize: number;
};

/**
 * Category with count for browsing
 */
export type CategoryOption = {
  value: ResourceCategory | 'ALL';
  label: string;
  count?: number;
};

